export interface Testimonial {
  name: string
  role: string
  country: string
  /** ISO 3166-1 alpha-2 code, used for the flag image */
  countryCode: string
  text: string
}

/**
 * Sample personas for the design preview only — not verified customer feedback.
 * Swap these for authentic buyer testimonials before publishing.
 */
export const testimonials: Testimonial[] = [
  {
    name: 'Michael Thompson',
    role: 'Fire Service Instructor',
    country: 'United States',
    countryCode: 'us',
    text: 'Having all these training topics organized in one place would save me a lot of preparation time. The building diagrams and ready-to-teach material are exactly the kind of resources I look for when planning classes.',
  },
  {
    name: 'James Wilson',
    role: 'Fire Training Officer',
    country: 'United Kingdom',
    countryCode: 'gb',
    text: 'The visual approach is what stands out to me. Being able to show recruits a clear diagram instead of explaining everything through long paragraphs could make classroom sessions much easier to follow.',
  },
  {
    name: 'Daniel Mitchell',
    role: 'Fire Academy Instructor',
    country: 'Canada',
    countryCode: 'ca',
    text: 'The combination of six training volumes, instructor scenarios and assessment resources makes this a very useful concept. I especially like having materials for different stages of firefighter development.',
  },
]
